// @ts-nocheck
import palette from './palette';
import { createTheme } from '@mui/material/styles';
import { deepmerge } from '@mui/utils';
import skipperDefaultTheme from 'styles/skipper/skipperDefaultTheme';
import skipperDefaultPalette from 'styles/skipper/skipperDefaultPalette';
import componentThemeStyleOverrides from './componentThemeStyleOverrides';

export default createTheme(
  deepmerge(skipperDefaultTheme, {
    presence: {
      online: '#26d368',
      busy: '#e12f04',
      away: '#ffd200',
      offline: '#b6ced2',
      unknown: '#b6ced2',
    },
    page: {
      width: '76rem',
      pageMaxWidth: 1280,
      navWidth: 250,
    },
    palette,
    customSpacing: {
      dialog: {
        sectionMargin: 24,
        sectionDividerMargin: 16,
      },
      profile: {
        position: 44,
        marginTop: 69,
      },
    },
    components: {
      ...componentThemeStyleOverrides,
      // (notes - pearl) All color attrs are added in this file because the colors in `skipperDefaultTheme`,
      // the other file that consumes `componentThemeOverrides` needs to be used when theme colors
      // are overridden
      MuiButton: {
        ...componentThemeStyleOverrides.MuiButton,
        defaultProps: {
          color: 'inherit',
        },
      },
      MuiCheckbox: {
        styleOverrides: {
          root: {
            color: skipperDefaultPalette.text.primary,
          },
        },
      },
      MuiDialogContentText: {
        styleOverrides: {
          ...componentThemeStyleOverrides.MuiDialogContentText.styleOverrides,
          root: {
            ...componentThemeStyleOverrides.MuiDialogContentText.styleOverrides.root,
            color: skipperDefaultPalette.text.gray1,
          },
        },
      },
      MuiFormLabel: {
        styleOverrides: {
          root: {
            color: skipperDefaultPalette.text.gray1,
          },
        },
      },
      MuiFormHelperText: {
        styleOverrides: {
          ...componentThemeStyleOverrides.MuiFormHelperText.styleOverrides,
          root: {
            ...componentThemeStyleOverrides.MuiFormHelperText.styleOverrides.root,
            color: skipperDefaultPalette.text.gray1,
          },
        },
      },
      MuiListItemText: {
        styleOverrides: {
          secondary: {
            color: skipperDefaultPalette.text.gray1,
          },
        },
      },
      MuiTable: {
        styleOverrides: {
          ...componentThemeStyleOverrides.MuiTable.styleOverrides,
          root: {
            ...componentThemeStyleOverrides.MuiTable.styleOverrides.root,
            '& caption': {
              ...componentThemeStyleOverrides.MuiTable.styleOverrides.root['& caption'],
              color: skipperDefaultPalette.text.gray1,
            },
          },
        },
      },
    },
  }),
);
